<template>
  <footer>
    <p class="nano"> Copyright 2020 - </p>
    <p class="nano">
      Made With <font-awesome-icon icon="heart" style="color:#a5043a" /> By Shabnam
    </p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
</style>
